// extracted by mini-css-extract-plugin
export default {"checked":"Checkbox_checked__goBsR","container":"Checkbox_container__YzZRu"};